export const environment = {
  AUTH0_DOMAIN: 'ng-todo-prod.eu.auth0.com',
  AUTH0_CLIENT_ID: 'scGsHpn9HLipSjgxvndkrOdfjHz1XFOo',
};
